type LoadingIndicatorProps = {
  label?: string;
};

export function LoadingIndicator({
  label = "Загрузка…",
}: LoadingIndicatorProps) {
  return (
    <div className="hw-loading" role="status" aria-live="polite">
      <span className="hw-loading__spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
